import React, { lazy, Suspense } from "react"
import { StaticImage } from "gatsby-plugin-image"
import FooterContent from "./hardcoded-footer-content"
import { count } from "console"

interface IFooterProps {
  conedFooter?: boolean | null | undefined
}

const year = new Date().getFullYear()
const ConedFooterColumn1 = React.lazy(
  () => import(`./pts-footer-columns/coned-footer-column1`)
)
const ConedFooterColumn2 = React.lazy(
  () => import(`./pts-footer-columns/coned-footer-column2`)
)
const PtsFooterColumn3 = React.lazy(
  () => import(`./pts-footer-columns/pts-footer-column3`)
)

const resultFooter = (
  <footer className="text-white">
    <div className="bg-blue pt-8 pb-4">
      <div className="container max-w-[1232px] px-4 mx-auto">
        <StaticImage
          src="../images/georgian-college-logo-2017.svg"
          alt="Georgian College"
          layout="fixed"
          width={165}
        />
      </div>
      <div className="container max-w-[1232px] mx-auto">
        <FooterContent />
      </div>
    </div>
    <div className="bg-gray">
      <div className="container max-w-[1232px] px-4 text-sm lg:text-base mx-auto py-4">
        One Georgian Dr., Barrie ON L4M 3X9 |{` `}
        <a
          target="_blank"
          href="tel:7057281968"
          title="Call us!"
          rel="noreferrer"
        >
          705.728.1968
        </a>
        {` `}|{` `}
        <a
          target="_blank"
          href="mailto:inquire@georgiancollege.ca"
          title="Email us!"
          rel="noreferrer"
        >
          inquire@georgiancollege.ca
        </a>
      </div>
    </div>
    <div className="bg-white text-black">
      <div className="container max-w-[1232px] text-sm lg:text-base px-4 mx-auto py-4">
        Copyright © {year} Georgian College.
      </div>
    </div>
  </footer>
)

const Footer = (props: IFooterProps): JSX.Element => {
  if (props.conedFooter) {
    return (
      <Suspense>
        <footer id="mainFooter" className="text-white">
          <div className="bg-blue pt-8 pb-4">
            <div className="container max-w-[1232px] mx-auto">
              <div className="main-container px-4 mx-auto lg:flex">
                <div className="pl-3.5 pr-3.5 lg:mt-0 flex gap-4 lg:w-3/12 items-center">
                  <div id="footerLogo">
                    <a href="/" title="Georgian College">
                      <StaticImage
                        src="../images/georgian-college-logo-2017.svg"
                        alt="Georgian College Accelerator Logo"
                      />
                    </a>
                  </div>
                </div>
                <div className="pl-3.5 pr-3.5 lg:mt-0 flex gap-4 lg:w-3/12">
                  <div>
                    <div className="textwidget">
                      <Suspense>
                        <ConedFooterColumn1 />
                      </Suspense>
                    </div>
                  </div>
                </div>
                <div className="pl-3.5 pr-3.5 lg:mt-0 flex gap-4 lg:w-3/12">
                  <div>
                    <div className="textwidget">
                      <Suspense>
                        <ConedFooterColumn2 />
                      </Suspense>
                    </div>
                  </div>
                </div>
                <div className="pl-3.5 pr-3.5 lg:mt-0 flex gap-4 lg:w-3/12">
                  <div>
                    <div className="textwidget">
                      <Suspense>
                        <PtsFooterColumn3 />
                      </Suspense>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-gray">
            <div className="container max-w-[1232px] text-sm lg:text-base px-4 mx-auto py-4">
              Copyright © {year} Georgian College.
            </div>
          </div>
        </footer>
      </Suspense>
    )
  }

  return resultFooter
}

export default Footer
